import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import scrollTo from 'gatsby-plugin-smoothscroll'
import styled from 'styled-components'
import PATHS, { LANDING_PAGE_SECTIONS } from 'src/utils/paths'
import withLocation from 'src/hoc/withLocation'
import useScrollDetector from 'src/hooks/useScrollDetector'
import { isNotNilOrEmpty } from 'src/utils/ramda'
import LogoDark from 'src/assets/images/vectors/panda-logo-dark.svg'
import LanguagePicker from 'src/features/locales/LanguagePicker'
import Button from 'src/components/atoms/Button'

const NonAuthNavigationWeb = props => {
  const hasScrolled = useScrollDetector(100)
  const { t } = useTranslation()
  const {
    location: { pathname, hash },
    navigate
  } = props

  useEffect(() => {
    if (isNotNilOrEmpty(hash)) {
      setTimeout(() => scrollTo(hash), 500)
    }
  }, [hash])

  const navigateToPath = path => () => navigate(path)

  const scrollToSection = id => () => navigate(`/#${id}`)
  
  const isHomepage = pathname === PATHS.homepage
  const [primaryState, setPrimaryState] = useState(isHomepage && !hasScrolled)

  useEffect(() => {
    setPrimaryState(isHomepage && !hasScrolled)
  }, [hasScrolled, isHomepage])

  return (
    <StyledTopNav primaryState={primaryState}>
      <StyledTopNavSection>
        <div className='top-nav-menu__items-container'>
          <a href={`/#${LANDING_PAGE_SECTIONS.howItWorksSection}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.howItWorksSection)}>
            {t('navigation.whoIsPanda')}
          </a>
          <a href={`/#${LANDING_PAGE_SECTIONS.history}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.history)}>
            {t('navigation.history')}
          </a>
          <a href={`/#${LANDING_PAGE_SECTIONS.faq}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.faq)}>
            {t('navigation.faq')}
          </a>
          <a href={`/#${LANDING_PAGE_SECTIONS.contactSection}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.contactSection)}>
            {t('navigation.contact')}
          </a>
        </div>
      </StyledTopNavSection>
      <StyledTopNavSection>
        <img className='top-nav-logo__image' src={LogoDark} alt='logo' />
      </StyledTopNavSection>
      <StyledTopNavSection>
        <div className='top-nav-logo__actions-container'>
          <Button onClick={navigateToPath(PATHS.logIn)} size='normal' color='secondary'>{t('navigation.login')}</Button>
          <LanguagePicker />
        </div>
      </StyledTopNavSection>
    </StyledTopNav>
  )
}

export default withLocation(NonAuthNavigationWeb)

const StyledTopNav = styled.div`
  height: 72px;
  width: 100%;
  position: fixed;
  background-color: ${props => props.primaryState ? 'transparent' : props.theme.palette.common.white};
  top: 0;
  display: flex;
  z-index: 100;
`

const StyledTopNavSection = styled.div`
  height 100%;
  width: 33%;
  display: flex;

  .top-nav-logo__image {
    width: 187px;
    height: 39px;
    margin: auto;
  }

  .top-nav-menu__items-container {
    display: flex;
    padding-left: 32px;
    margin: auto;

    a {
      margin-left: 24px;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
      cursor: pointer;

      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }

  .top-nav-logo__actions-container {
    display: flex;
    padding-right: 32px;
    margin: auto;
    align-items: center;
    gap: 24px;

    button {
      width: 210px;
      text-transform: uppercase;
    }
  }
`
